export default __webpack_public_path__ + "assets/woff2/4743c758a952f2bd4a35d4e42afc002b.woff2";